import { render, staticRenderFns } from "./LiveAddStatForm.vue?vue&type=template&id=ec80dc2a"
import script from "./LiveAddStatForm.vue?vue&type=script&lang=js"
export * from "./LiveAddStatForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports